import React from "react";

export const PageLoader = () => (
  <div className="max-w-3xl mx-auto px-5 py-16 animate-pulse space-y-4">
    <div className="h-10 w-2/3 bg-pillet-card" />
    <div className="h-4 w-full bg-pillet-card/60" />
    <div className="h-4 w-5/6 bg-pillet-card/60" />
    <div className="h-40 w-full bg-pillet-card/40 mt-8" />
  </div>
);

export const SyncPending = () => (
  <div className="max-w-2xl mx-auto px-5 py-24 text-center">
    <div className="inline-block w-8 h-8 border-2 border-pillet-sage border-t-transparent rounded-full animate-spin mb-6" />
    <h2 className="font-heading font-bold text-xl uppercase text-white mb-2">
      Synchronisation en cours
    </h2>
    <p className="text-pillet-muted text-sm">
      Le contenu est en cours de récupération depuis Notion. Rechargez la page dans un instant.
    </p>
  </div>
);
